module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.ismajor) ? _c('h2', [_vm._v(" " + _vm._s(_vm.header) + " ")]) : _c('h3', [_vm._v(" " + _vm._s(_vm.header) + " ")]), _vm._v(" "), _c('table', [_c('col', {
    staticStyle: {
      "width": "10%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "50%"
    }
  }), _vm._v(" "), _c('col', {
    staticStyle: {
      "width": "40%"
    }
  }), _vm._v(" "), _c('thead', [_c('tr', _vm._l((_vm.titleCase(_vm.headings)), function(heading) {
    return _c('th', [_vm._v("\n                    " + _vm._s(heading) + " ")])
  }))]), _vm._v(" "), _c('tbody', _vm._l((_vm.sortedItems), function(item) {
    return _c('tr', _vm._l((_vm.headings), function(heading) {
      return _c('td', [_vm._v("\n                    " + _vm._s(item[heading]) + "\n                ")])
    }))
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ea599a4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cv/generictable.vue
// module id = 201
// module chunks = 0